import { Route } from '@/app/router'
import QuantityDisabled from '@/middleware/QuantityDisabled'

const GroupedSale = () => import('./index.vue')

const GroupedSaleProps = ['page', 'perPage']

export default new Route('/grouped-sales/:id', GroupedSale)
	.as('Dashboard:GroupedSale')
	.props(GroupedSaleProps)
	.permissions(['VIEW_GROUPED_SALE', 'PARTS_QUANTITY_DISABLED'])
	.middlewares(QuantityDisabled)
